import { ButtonTheme } from 'components/Button';
import { Menu } from 'components/Menu';
import { capitalize } from 'lodash';
import React, { useCallback } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { TimescaleArray, TimescalePeriod } from 'types/types';
import { NumberSpinner } from './NumberSpinner';

const DateFieldWidth = 120;

interface Props {
  timescale: TimescaleArray;
  onChange: (timescale: TimescaleArray) => void;
  style?: StyleProp<ViewStyle>;
}

export const TimescaleField: React.FC<Props> = ({
  onChange,
  timescale: [value, unit],
  style,
}) => {
  const handleValueChange = useCallback(
    (newValue: number) => {
      onChange([newValue, unit]);
    },
    [onChange, unit],
  );

  const handleUnitChange = useCallback(
    (newUnit: TimescalePeriod) => onChange([value, newUnit]),
    [onChange, value],
  );

  return (
    <View style={[{ width: DateFieldWidth, flexDirection: 'row' }, style]}>
      <NumberSpinner
        value={value}
        onChange={(val) => handleValueChange(val)}
        small
        style={{
          marginRight: -1,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          flex: 1,
        }}
      />
      <Menu
        width={DateFieldWidth}
        buttonConfig={{
          buttonTheme: ButtonTheme.secondary,
          text: `${capitalize(unit[0])}`,
          textWeight: 'regular',
          style: {
            paddingHorizontal: 0,
            justifyContent: 'center',
            width: 31,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            backgroundColor: '#ffffff',
          },
        }}
        options={[
          {
            text: `Day${value > 1 ? 's' : ''}`,
            onPress: () => handleUnitChange(TimescalePeriod.day),
          },
          {
            text: `Week${value > 1 ? 's' : ''}`,
            onPress: () => handleUnitChange(TimescalePeriod.week),
          },
          {
            text: `Month${value > 1 ? 's' : ''}`,
            onPress: () => handleUnitChange(TimescalePeriod.month),
          },
          {
            text: `Year${value > 1 ? 's' : ''}`,
            onPress: () => handleUnitChange(TimescalePeriod.year),
          },
        ]}
      />
    </View>
  );
};
